import { FC } from 'react';

import { Text } from '@/core/tamagoshi/Text/Text';
import { Toggle } from '@/core/tamagoshi/Toggle/Toggle';
import { Gtm } from '@/core/tracking/utils/Gtm';
import {
  headerFilterLabel,
  headerTitle,
} from '@/domains/productDiscovery/ArticleReviews/translations';

import styles from './B2BHeader.module.scss';

interface B2BHeaderProps {
  onChange: () => void;
  state: boolean;
}

export const B2BFilter: FC<B2BHeaderProps> = ({ onChange, state }) => {
  const handleChange = () => {
    onChange();
    Gtm.push({
      event: 'interaction_click on a block',
      amp_event_name: 'Click on a block',
      block_clicked: state ? 'Deactivate pro reviews' : 'Activate pro reviews',
      event_trigger: 'Product reviews',
      page_type: 'Product Page',
    });
  };

  return (
    <header className={styles.header}>
      <Text tag="h1" type="h4" weight="bold" className={styles.title}>
        {headerTitle}
      </Text>
      <div className={styles.switch}>
        <Text tag="label" type="body2" weight="semiBold">
          {headerFilterLabel}
        </Text>
        <Toggle checked={state} id="reviews-kind" onChange={handleChange} />
      </div>
    </header>
  );
};
